<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
      <h1>Positions</h1>
      <b-avatar
        button
        class="align-center mr-3 mb-3"
        title="Add a Position"
        @click="addPositionOpen=true"
        variant="primary"
        icon="plus"
        v-if="positions.length > 0"
      ></b-avatar>
      </b-col>
      <b-col cols="12">
        <add-position :trigger="addPositionOpen" @triggerUpdate="updateTrigger" />
        <b-table striped hover :items="positions" :fields="fields" show-empty>
          <template v-slot:empty>
            <b-container fluid>
              <b-row>
                <b-col cols="12" md="4" class="mx-auto">
                  <h4 class="text-center">You haven't added any positions yet.</h4>
                  <b-button block @click="addPositionOpen=true" variant="primary">Add a position</b-button>
                </b-col>
              </b-row>
            </b-container>
          </template>
          <template v-slot:cell(actions)="data">
            <b-container fluid>
              <b-row>
                <b-col cols="12" md="6">
                  <b-button
                    variant="danger"
                    title="Delete"
                    block
                    @click="deletePosition(data.item.id)"
                  >
                    <b-icon-trash />&nbsp;Delete
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from 'moment';
import AddPosition from '@/components/modals/addPosition';
import Position from '@/fstore/collections/Position';
import fstore from '@/fstore';

export default {
  name: 'Positions',
  components:{
    AddPosition
  },
  data() {
    return {
      addPositionOpen: false,
      positions: [],
      fields: [
        { 
          key: 'dateAdded',
          sortable: true,
          formatter: value => {
            let d = moment(value);
            if(!d.isValid())
              d = moment(value.toDate());

            return d.format('MMM. Do, YYYY h:MMa');
          }
        },
        {
          key: 'name',
          sortable: true
        },
        "Actions"
      ]
    }
  },
  firestore: {
    positions: fstore.db.collection('jobtitles').where('active', '==', true)
  },
  methods:{
    updateTrigger(value) {
      this.addPositionOpen = value
    },
    async deletePosition (uid) {
        const confirmed = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this position. Once a position has been deleted, it cannot be recovered.', {
          title: 'Are you sure?',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete this position',
          cancelTitle: 'Cancel',
          cancelVariant: 'text',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        });

        if(confirmed){
          try {
            this.$store.dispatch('app/setOverlay', true);
            await Position.remove(uid);
            this.$store.dispatch('app/setOverlay', false);
          }catch(err) {
            console.error(err);
          }
        }
    }
  }
}
</script>